module.exports = __webpack_public_path__ + "img/logo-attend-stream.2af19ec9.png";